import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import { Alert } from 'react-bootstrap'
import { ThemeProvider } from 'styled-components'
import themes from '../../styles/themes'
import * as actions from '../../state/actions'
import * as storage from '../../utils/storage'
import style from './styles.less'

import { renderToStaticMarkup } from 'react-dom/server'
import { withLocalize } from 'react-localize-redux'
import globalTranslations from '../../translations/global.json'
import { Helmet } from 'react-helmet'
import { ToastContainer } from 'react-toastify'

class Base extends Component {
    constructor(props) {
        super(props)

        const languages = [
            { name: 'Español', code: 'es' },
            { name: 'English', code: 'en' }
        ]

        let navLanguage = navigator.language || navigator.userLanguage
        navLanguage = navLanguage.split('-')[0]

        if (!languages.find(language => language.code === navLanguage)) {
            navLanguage = 'es'
        }

        this.props.initialize({
            languages,
            translation: globalTranslations,
            options: {
                defaultLanguage: storage.get('language') || navLanguage,
                renderToStaticMarkup
            }
        })
        this.props.actions.previousPath(`${this.props.location.pathname}${this.props.location.search}`)
    }

    async componentDidMount() {
        const self = this
        try {
            if (!self.props.profile && storage.get(storage.accessTokenKey)) {
                await  self.props.actions.userGetProfile()
            }
            self.props.actions.isReady()
        } catch (error) {
            browserHistory.push('/manager/login')
        }
    }

    componentDidUpdate() {
        const { routing, isReady, profile, api } = this.props
        const location = routing && routing.locationBeforeTransitions
        const errorStatus = api && api.error && api.error.response && api.error.response.status && api.error.response.status

        // Check if user needs force password change and is from allowed apps
        const allowedAppsForForcePasswordChange = ['demo', 'academyvged']
        const userAppCodename = profile && profile.app && profile.app.codename
        const shouldForcePasswordChange = profile && profile.forcePasswordChange &&
            allowedAppsForForcePasswordChange.includes(userAppCodename)

        if (isReady && !profile && location && location.pathname !== '/manager/login') {
            browserHistory.push('/manager/login')
        } else if (isReady && shouldForcePasswordChange && location && location.pathname !== '/manager/force-password-change') {
            browserHistory.push('/manager/force-password-change')
        } else if (isReady && profile && (!profile.forcePasswordChange || !shouldForcePasswordChange) && location && (location.pathname === '/manager/login' || location.pathname === '/manager' || location.pathname === '/manager/' || location.pathname === '/manager/force-password-change')) {
            if (profile && profile.profile) {
                if (profile.profile > 0 && profile.profile <= 1000) {
                    browserHistory.push(this.props.previousPath && !this.props.previousPath.match(/\/manager($|\/$|\/login|\/app|\/account|\/stats|\/force-password-change)/) ? this.props.previousPath : `/manager/${profile.app.codename}/dashboard`)
                } else if (profile.profile === 2000) {
                    browserHistory.push(this.props.previousPath && !this.props.previousPath.match(/\/manager($|\/$|\/login|\/force-password-change)/) ? this.props.previousPath : '/manager/app')
                } else {
                    browserHistory.push('/manager/login')
                }
            }
        }

        if (errorStatus === 401) {
            if (location && location.pathname !== '/manager/login') {
                browserHistory.push('/manager/login')
            }
        }
    }

    render() {
        const self = this
        let alert
        let theme = themes.default
        const { app, api, profile } = self.props
        if (app && app.theme) {
            theme = app.theme
        }
        theme.brand = {
            primary: '#428bca',
            success: '#5cb85c',
            info: '#5bc0de',
            warning: '#f0ad4e',
            danger: '#d9534f'
        }
        if (api && api.error && !(api.error.response && api.error.response.status && api.error.response.status === 401)) {
            let extraInfo1
            let extraInfo2
            if (api.error.detail) {
                extraInfo1 = <p>{api.error.detail}</p>
            }
            if (api.error.response && api.error.response.data && api.error.response.data.error) {
                extraInfo2 = (
                    <div>
                        <p className="error">{api.error.response.data.error.message || ''}</p>
                        <p className="error">{JSON.stringify(api.error.response.data.error.detail || '')}</p>
                        <p className="error">{(api.error.response.data.error.code && ('Code: ' + api.error.response.data.error.code)) || ''}</p>
                    </div>
                )
            }
            alert = (
                <div className={style.error}>
                    <Alert id="alertError" bsStyle="danger" onDismiss={self.props.actions.apiClean.bind(self)}>
                        <strong>{api.error.message}</strong>
                        {extraInfo1}
                        {extraInfo2}
                    </Alert>
                </div>
            )
        }
        return (
            <ThemeProvider theme={theme}>
                <div>
                    {
                        (profile && profile.profile) && (process.env.MT_ENV === 'production' || process.env.MT_ENV === 'staging') && (
                            <Helmet>
                                <script src="https://status.chat-tonic.com/embed/script.js"></script>
                            </Helmet>
                        )
                    }
                    {process.env.MT_ENV === 'development' && alert}
                    <ToastContainer />
                    {self.props.children}
                </div>
            </ThemeProvider>
        )
    }
}

function mapStateToProps(state) {
    return {
        api: state.api,
        app: state.app,
        isReady: state.isReady,
        profile: state.profile,
        routing: state.routing,
        previousPath: state.previousPath
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Base))
